module.exports = __webpack_public_path__ + "img/bk.2c5527d7.png";